import React from 'react'
import BasicModal from '@/components/UI/Dialog'
import { Box, Typography, ButtonProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function ConfirmationModal(props: any) {
  const { t } = useTranslation('translation')

  const footerActions = [
    {
      title: props.secondaryButtonText
        ? props.secondaryButtonText
        : t('No, Cancel'),
      variant: 'outlined' as const,
      color: 'primary' as ButtonProps['color'],
      onClick: props.confirmOnHideHandler
        ? props.confirmOnHideHandler
        : props.onHide,
    },
  ]

  if (props.confirmHandler) {
    footerActions.push({
      title: props.buttonText ? props.buttonText : t('Yes, Delete'),
      variant: 'outlined' as const,
      color: (props.positiveAction
        ? 'primary'
        : 'error') as ButtonProps['color'],
      onClick: props.confirmHandler,
    })
  }

  return (
    <BasicModal
      open={props.show}
      onClose={props.onHide}
      sx={{ width: props.size === 'lg' ? '600px' : '500px', height: 'auto' }}
      title={props.headerMessage}
      footerActions={footerActions}
    >
      <Box mt={2}>
        <Typography variant="body1" sx={{ fontWeight: 400 }}>
          {props.message}
        </Typography>
      </Box>
    </BasicModal>
  )
}
